import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['../components/index.vue'],resolve)
    },
    {
      path: '/ours',
      name: 'ours',
      component: resolve => require(['../components/ours.vue'],resolve)
    },
    {
      path: '/private',
      name: 'private',
      component: resolve => require(['../components/private.vue'],resolve)
    },
    {
      path: '/chat',
      name: 'chat',
      component: resolve => require(['../components/chat.vue'],resolve)
    },
    {
      path: '/friend',
      name: 'friend',
      component: resolve => require(['../components/friend.vue'],resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../components/logins.vue'],resolve)
    },
    {
      path: '/user',
      name: 'user',
      redirect: '/user/account',
      component: resolve => require(['../components/user/user.vue'],resolve),
      children: [
        {
          path: 'account',
          name: 'account',
          component: resolve => require(['../components/user/account.vue'],resolve)
        },
        {
          path: 'editorial',
          name: 'editorial',
          component: resolve => require(['../components/user/editorial.vue'],resolve)
        },
        {
          path: 'credit',
          name: 'credit',
          component: resolve => require(['../components/user/creditCard.vue'],resolve)
        },
        {
          path: 'changecredit',
          name: 'changecredit',
          component: resolve => require(['../components/user/changeCreditCard.vue'],resolve)
        },
        {
          path: 'withdraw',
          name: 'withdraw',
          redirect: 'withdraw/gift',
          component: resolve => require(['../components/user/withdraw.vue'],resolve),
          children: [
            {
              path: 'gift',
              name: 'gift',
              component: resolve => require(['../components/user/withdrawGift.vue'],resolve)
            },
            {
              path: 'record',
              name: 'record',
              component: resolve => require(['../components/user/withdrawRecord.vue'],resolve)
            }
          ] 
        },
        {
          path: 'recharge',
          name: 'recharge',
          redirect: 'recharge/charge',
          component: resolve => require(['../components/user/recharge.vue'],resolve),
          children: [
            {
              path: 'charge',
              name: 'charge',
              component: resolve => require(['../components/user/rechargeOnline.vue'],resolve)
            },
            {
              path: 'record',
              name: 'record',
              component: resolve => require(['../components/user/rechargeRecord.vue'],resolve)
            }
          ] 
        }
      ]
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js